var exports = {
  "p_": "list__UK2EdR",
  "uW": "section__X08eNC",
  "AS": "item__qxrwnb",
  "hj": "trailingAction__qSqv6F",
  "Pj": "nestedSection__8Qf4Ug",
  "vB": "hasTrailingAction__9dNcU8",
  "Pf": "label__jc5-P8",
  "nf": "link__NF4BZ1",
  "Wj": "nestedLink__X5eHIh",
  "iE": "leadingIcon__d0IREZ",
  "m6": "hoverChevron__QTjmyX",
  "HW": "expandedChevron__DoOchV",
  "iA": "iconSlot__l7Hfji",
  "Qs": "content__mKCYk8",
  "tC": "textWrapper__MKQhqq",
  "Qq": "text__nqCOlu",
  "sf": "externalLabel__4gbWcW",
  "U0": "condensed__-jY-0X",
  "Pg": "previewLabel__FNPc1M",
  "Xw": "externalIcon__5kmJFy",
  "Gc": "hardNavigationLabel__km8iXP",
  "Pm": "hardNavigationIcon__FGg2Lh",
};

module.exports = exports;
